import { TbInfoCircle, TbAlertTriangle, TbBulb } from 'react-icons/tb'; // Add suitable icons
import Text from '../../core/utils/Text';

export default function HintBox({
    type = 'hint',
    body,
    className = '',
}) {

    const styles = {
        info: {
            bgColor: 'bg-[#D9E1FF]',
            textColor: 'text-[#7694FF]',
            icon: <TbInfoCircle size={20} />,
        },
        warn: {
            bgColor: 'bg-orange-300',
            textColor: 'text-black',
            icon: <TbAlertTriangle size={20} />,
        },
        hint: {
            bgColor: 'bg-gray-200 dark:bg-gray-700',
            textColor: 'text-cBlue',
            icon: <TbBulb size={20} />,
        },
    };

    const { bgColor, textColor, icon } = styles[type] || styles.hint;

    return (
        <div
            className={`${bgColor} ${className} rounded-lg p-4 flex items-center gap-2 w-full`}>
            <h5 className={`${textColor} flex items-center gap-x-2 text-sm`}>
                {icon}
                {/* {type.charAt(0).toUpperCase() + type.slice(1)} */}
            </h5>
            <pre className='text-sm whitespace-pre-wrap'>
                <Text className={styles[type].textColor} tid={body} />
            </pre>
        </div>
    );
}
